import { PlantRoots } from "../../../../../api/types/plants";
import { CafsVariable } from "../../../../../types/cafs-variable";
import { SelectOption } from "../../../../../types/select-option";
import { useRootTypes } from "../../../api/useRootTypes";
import { CafsVariableType } from "../../../const/cafs-variable-type";

import { rootLayerDistributionFn } from "./functions/rootLayerDistributionFn";

export function useRootsVariables(): CafsVariable<PlantRoots>[] {
  const { rootTypes } = useRootTypes();
  return [
    {
      name: "RootsRemarks",
      type: CafsVariableType.Remarks,
    },
    {
      name: "RootDepthM",
      type: CafsVariableType.Input,
    },
    {
      name: "RootNPKUptakeEffectivityFactor",
      type: CafsVariableType.Input,
    },
    {
      name: "RootTypeId",
      type: CafsVariableType.Select,
      options: rootTypes?.map(rt => {
        return { label: rt.Name, id: rt.Id } as SelectOption;
      }),
    },
    {
      name: "RootLayerDistribution",
      type: CafsVariableType.Calculated,
      calculationFn: rootLayerDistributionFn,
      dependOn: ["RootTypeId"],
      data: rootTypes,
    },
  ];
}
